import { ILocaleCreatorInput } from "@src/i18n";
import { getRandomId } from "@src/utils/uid";
import { Children } from "react";

export const defaultRichTextElements: ILocaleCreatorInput["defaultRichTextElements"] =
  {
    br: () => <br key={getRandomId()} />,
    span: (parts) => (
      <span key={parts.join("-")}>{Children.toArray(parts)}</span>
    ),
    p: (parts) => <p key={parts.join("-")}>{Children.toArray(parts)}</p>,
    strong: (parts) => (
      <strong key={parts.join("-")}>{Children.toArray(parts)}</strong>
    ),
  };
